import { useCallback, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../store';
import { identityActions, selectIdentity } from '../store/entities/identity';
import { userService } from '@api/services/services';

export const useUserPageSize = () => {
  const dispatch = useAppDispatch();
  const identity = useAppSelector(selectIdentity);
  const [savingPageSize, setSavingPageSize] = useState(false);

  const setPageSize = useCallback(
    async (nextSize: number) => {
      setSavingPageSize(true);
      try {
        const preferences = await userService.getPreferences(identity.id);
        await userService.updatePreferences(identity.id, { ...preferences.data, pageSize: nextSize });
        dispatch(identityActions.success({ ...identity, rowsCount: nextSize }));
      } finally {
        setSavingPageSize(false);
      }
    },
    [dispatch, identity],
  );

  return { pageSize: identity.rowsCount, savingPageSize, setPageSize };
};
